/* RESPONSIBLE TEAM: team-inbox-management */
import Route from '@ember/routing/route';

export default class WelcomeHelpdeskRoute extends Route {}
